import { mapSiteDtoToModel, mapSiteModelToDto } from '@hotjar/site';
import { mapOrganizationDtoToModel, mapOrganizationModelToDto } from '@hotjar/organization';

import type { UserResources as UserResourcesDto } from './dto';
import type { UserResources as UserResourcesModel } from './model';

export function userResourcesDtoToModel(userResources: UserResourcesDto): UserResourcesModel {
  const organizations = userResources.organizations.map((organization) =>
    mapOrganizationDtoToModel(organization),
  );

  return {
    sites: userResources.sites.map((site) => mapSiteDtoToModel(site, organizations)),
    organizations,
  };
}

export function userResourcesModelToDto(userResources: UserResourcesModel): UserResourcesDto {
  const organizations = userResources.organizations.map((organization) =>
    mapOrganizationModelToDto(organization),
  );

  return {
    organizations,
    sites: userResources.sites.map((site) => mapSiteModelToDto(site, organizations)),
  };
}
